export default __webpack_public_path__ + "static/media/cross-sign.dbfea3ff.svg";